export interface HotTopic {
  id: string;
  title: string;
  heat: string;
  tag: string;
  img: string;
}

export interface CommentItem {
  id: string;
  name: string;
  avatar: string;
  tag: string;
  topic: string;
  text: string;
  likes: string;
  replies: string;
  hot: boolean;
}

export interface BarrageItem {
  id: string;
  text: string;
  color: string;
}

export interface MemeItem {
  id: string;
  title: string;
  img: string;
  download: string;
  category: string;
}

export interface JokeItem {
  id: string;
  title: string;
  text: string;
  author: string;
  likes: string;
  category: string;
}

export interface ReactionItem {
  id: string;
  title: string;
  source: string;
  img: string;
  comments: string;
}

export interface FaqItem {
  id: string;
  q: string;
  a: string;
}

export const hotTopics: HotTopic[] = [
  {
    id: 't1',
    title: '苏晚晴深夜同框',
    heat: '842万',
    tag: '恋情瓜',
    img: 'https://readdy.ai/api/search-image?query=Playful%20flat%20vector%20illustration%20of%20a%20cute%20watermelon%20and%20two%20hearts%20on%20a%20phone%20screen%2C%20gossip%20romance%20news%20theme%2C%20soft%20coral%20red%20and%20cream%20background%2C%20minimal%20cartoon%20style%2C%20warm%20lighting%2C%20cheerful%20atmosphere&width=900&height=600&seq=gua-topic-01&orientation=landscape',
  },
  {
    id: 't2',
    title: '陈屿川综艺翻车名场面',
    heat: '521万',
    tag: '综艺',
    img: 'https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20surprised%20cute%20cartoon%20star%20falling%20down%20during%20a%20funny%20variety%20show%20game%2C%20watermelon%20melons%20flying%20around%2C%20playful%20comedy%20gossip%20theme%2C%20cream%20and%20leaf%20green%20palette%2C%20minimal%20style&width=900&height=600&seq=gua-topic-02&orientation=landscape',
  },
  {
    id: 't3',
    title: '林知夏新剧造型被嘲',
    heat: '368万',
    tag: '造型',
    img: 'https://readdy.ai/api/search-image?query=Fun%20flat%20illustration%20of%20a%20dramatic%20cartoon%20actress%20with%20funny%20exaggerated%20costume%20and%20wavy%20hair%20standing%20on%20stage%2C%20netizens%20commenting%20bubbles%20around%2C%20watermelon%20gossip%20theme%2C%20cream%20background%2C%20warm%20coral%20tones%2C%20minimal%20vector&width=900&height=600&seq=gua-topic-03&orientation=landscape',
  },
  {
    id: 't4',
    title: '白屿洲机场生图状态',
    heat: '299万',
    tag: '生图',
    img: 'https://readdy.ai/api/search-image?query=Modern%20flat%20illustration%20of%20a%20stylish%20sunglasses%20cartoon%20man%20dragging%20luggage%20at%20airport%2C%20cameras%20and%20fans%20around%2C%20gossip%20celebrity%20theme%2C%20watermelon%20green%20and%20cream%20palette%2C%20minimal%20clean%20vector&width=900&height=600&seq=gua-topic-04&orientation=landscape',
  },
  {
    id: 't5',
    title: '顾言川获奖感言太敢说',
    heat: '176万',
    tag: '颁奖礼',
    img: 'https://readdy.ai/api/search-image?query=Cheerful%20flat%20illustration%20of%20a%20cartoon%20singer%20holding%20a%20gold%20trophy%20on%20stage%20with%20confetti%2C%20bold%20speech%20bubble%20with%20funny%20text%2C%20watermelon%20gossip%20award%20theme%2C%20cream%20background%2C%20warm%20amber%20and%20coral%20colors%2C%20minimal%20vector&width=900&height=600&seq=gua-topic-05&orientation=landscape',
  },
];

export const commentItems: CommentItem[] = [
  {
    id: 'c1',
    name: '月亮不营业',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20flat%20cartoon%20avatar%20portrait%20of%20a%20smiling%20moon%20with%20nightcap%2C%20cream%20background%2C%20minimal%20warm%20colors%2C%20friendly%20round%20face&width=200&height=200&seq=gua-ava-01&orientation=squarish',
    tag: '热评',
    topic: '苏晚晴深夜同框',
    text: '不是我说，这套路怎么跟上一季一模一样？狗仔都学会炒冷饭了，能不能来点新的剧本，我都替编剧累。',
    likes: '12.6万',
    replies: '3204',
    hot: true,
  },
  {
    id: 'c2',
    name: '吃瓜不吐籽',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20flat%20cartoon%20avatar%20of%20a%20happy%20watermelon%20character%20winking%2C%20leaf%20green%20and%20cream%20background%2C%20minimal%20vector%2C%20playful%20and%20cute&width=200&height=200&seq=gua-ava-02&orientation=squarish',
    tag: '弹幕',
    topic: '陈屿川综艺翻车名场面',
    text: '笑死，上一秒还在立高冷人设，下一秒直接社死现场。综艺之神果然不会放过每一个嘴硬的人哈哈哈哈。',
    likes: '8.2万',
    replies: '1902',
    hot: true,
  },
  {
    id: 'c3',
    name: '瓜田里的猹',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20flat%20cartoon%20avatar%20of%20a%20cheeky%20raccoon%20peeking%20from%20a%20watermelon%20field%2C%20cream%20background%2C%20minimal%20warm%20vector%20style&width=200&height=200&seq=gua-ava-03&orientation=squarish',
    tag: '热评',
    topic: '林知夏新剧造型被嘲',
    text: '造型师是不是跟姐姐有仇？这妆造我都想替她报警了，硬生生把气质拍成隔壁村口大姐。',
    likes: '6.7万',
    replies: '1108',
    hot: true,
  },
  {
    id: 'c4',
    name: '半夜不睡觉',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20flat%20cartoon%20avatar%20of%20a%20sleepy%20owl%20with%20glasses%20and%20night%20moon%2C%20cream%20background%2C%20minimal%20cool%20colors%2C%20friendly%20vector&width=200&height=200&seq=gua-ava-04&orientation=squarish',
    tag: '神梗',
    topic: '白屿洲机场生图状态',
    text: '生图都这么顶？确认过眼神，是那个靠脸吃饭还非要拼实力的男人。建议把这张图裱起来当门面。',
    likes: '5.3万',
    replies: '876',
    hot: false,
  },
  {
    id: 'c5',
    name: '猹本猹',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20flat%20cartoon%20avatar%20of%20a%20smiling%20badger%20holding%20a%20small%20watermelon%2C%20cream%20background%2C%20minimal%20warm%20vector%20style%2C%20playful&width=200&height=200&seq=gua-ava-05&orientation=squarish',
    tag: '弹幕',
    topic: '顾言川获奖感言太敢说',
    text: '内娱活人+1，敢在台上说实话的真的不多了，这段感言我能反复看十遍，真·人间清醒。',
    likes: '4.9万',
    replies: '654',
    hot: false,
  },
  {
    id: 'c6',
    name: '键盘上的瓜',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20flat%20cartoon%20avatar%20of%20a%20cat%20typing%20on%20a%20laptop%20with%20comment%20bubble%2C%20cream%20background%2C%20minimal%20coral%20colors%2C%20friendly%20vector&width=200&height=200&seq=gua-ava-06&orientation=squarish',
    tag: '段子',
    topic: '苏晚晴深夜同框',
    text: '经纪人：记住你俩是来对戏的。粉丝：你们这戏可真够投入的，我都怕你俩闪婚。',
    likes: '3.8万',
    replies: '421',
    hot: false,
  },
  {
    id: 'c7',
    name: '可乐不加冰',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20flat%20cartoon%20avatar%20of%20a%20happy%20penguin%20with%20a%20cola%20can%2C%20cream%20background%2C%20minimal%20cool%20blue%20and%20white%2C%20friendly%20vector&width=200&height=200&seq=gua-ava-07&orientation=squarish',
    tag: '热评',
    topic: '陈屿川综艺翻车名场面',
    text: '陈哥你糊涂啊，别人是来上综艺的，你是来给剪辑老师送素材的，这期笑点直接拉满。',
    likes: '3.1万',
    replies: '289',
    hot: false,
  },
  {
    id: 'c8',
    name: '熬夜冠军',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20flat%20cartoon%20avatar%20of%20a%20tired%20cat%20with%20coffee%20cup%20and%20dark%20circles%2C%20cream%20background%2C%20minimal%20warm%20vector%20style&width=200&height=200&seq=gua-ava-08&orientation=squarish',
    tag: '弹幕',
    topic: '林知夏新剧造型被嘲',
    text: '评论区人均造型总监，笑不活了。要我说，姐姐演技在线就够了，造型咱们可以dream一个下季逆袭。',
    likes: '2.4万',
    replies: '198',
    hot: false,
  },
];

export const barrageItems: BarrageItem[] = [
  { id: 'b1', text: '哈哈哈哈这波操作我直接笑飞', color: '#f2555a' },
  { id: 'b2', text: '前排围观，今晚的瓜有点大', color: '#4aa96c' },
  { id: 'b3', text: '弹幕护体，礼貌吃瓜', color: '#f2a33c' },
  { id: 'b4', text: '这届网友真是被才华耽误的段子手', color: '#d76fd0' },
  { id: 'b5', text: '瓜很甜，我先干为敬', color: '#f2555a' },
  { id: 'b6', text: '别停别停，再爆点细节', color: '#3aa6a8' },
  { id: 'b7', text: '笑不活了家人们', color: '#4aa96c' },
  { id: 'b8', text: '这剧情编剧都不敢这么写', color: '#d76fd0' },
  { id: 'b9', text: '蹲一个后续更新', color: '#f2a33c' },
  { id: 'b10', text: '评论区比正片好看系列', color: '#f2555a' },
  { id: 'b11', text: '有瓜一起吃，快乐加倍', color: '#3aa6a8' },
  { id: 'b12', text: '弹幕区的快乐我懂', color: '#d76fd0' },
];

export const memes: MemeItem[] = [
  {
    id: 'm1',
    title: '震惊！我裂开了',
    img: 'https://readdy.ai/api/search-image?query=Funny%20flat%20cartoon%20sticker%20of%20a%20shocked%20watermelon%20splitting%20open%20with%20big%20surprised%20eyes%2C%20cream%20background%2C%20minimal%20coral%20red%20palette%2C%20meme%20expression%20style&width=600&height=600&seq=gua-meme-01&orientation=squarish',
    download: '12.4万',
    category: '惊讶',
  },
  {
    id: 'm2',
    title: '在线吃瓜中',
    img: 'https://readdy.ai/api/search-image?query=Funny%20flat%20cartoon%20sticker%20of%20a%20cute%20character%20eating%20watermelon%20while%20watching%20phone%2C%20drooling%20happily%2C%20cream%20background%2C%20minimal%20leaf%20green%20and%20coral%2C%20meme%20style&width=600&height=600&seq=gua-meme-02&orientation=squarish',
    download: '9.8万',
    category: '吃瓜',
  },
  {
    id: 'm3',
    title: '就这？就这？',
    img: 'https://readdy.ai/api/search-image?query=Funny%20flat%20cartoon%20sticker%20of%20a%20sarcastic%20dog%20with%20one%20raised%20eyebrow%20and%20judging%20expression%2C%20cream%20background%2C%20minimal%20warm%20amber%20tones%2C%20meme%20style&width=600&height=600&seq=gua-meme-03&orientation=squarish',
    download: '8.7万',
    category: '嘲讽',
  },
  {
    id: 'm4',
    title: '我不懂但我大受震撼',
    img: 'https://readdy.ai/api/search-image?query=Funny%20flat%20cartoon%20sticker%20of%20a%20confused%20cat%20with%20glasses%20and%20question%20marks%20around%20head%2C%20cream%20background%2C%20minimal%20coral%20red%2C%20meme%20expression%20style&width=600&height=600&seq=gua-meme-04&orientation=squarish',
    download: '7.3万',
    category: '惊讶',
  },
  {
    id: 'm5',
    title: '磕到了磕到了',
    img: 'https://readdy.ai/api/search-image?query=Cute%20flat%20cartoon%20sticker%20of%20two%20hearts%20and%20a%20blushing%20watermelon%20couple%2C%20cream%20background%2C%20minimal%20pink%20and%20coral%2C%20sweet%20meme%20style&width=600&height=600&seq=gua-meme-05&orientation=squarish',
    download: '6.9万',
    category: '嗑糖',
  },
  {
    id: 'm6',
    title: '本宫乏了',
    img: 'https://readdy.ai/api/search-image?query=Funny%20flat%20cartoon%20sticker%20of%20a%20lazy%20lying%20koala%20with%20bored%20expression%20holding%20tea%2C%20cream%20background%2C%20minimal%20soft%20purple%20and%20cream%2C%20meme%20style&width=600&height=600&seq=gua-meme-06&orientation=squarish',
    download: '5.6万',
    category: '摆烂',
  },
];

export const jokes: JokeItem[] = [
  {
    id: 'j1',
    title: '当狗仔问单身问题时',
    text: '记者：最近有在谈恋爱吗？偶像：我连觉都不够睡，谈什么恋爱，跟床单谈吗？粉丝：笑死，人间真实。',
    author: '瓜田不拾遗',
    likes: '8.1万',
    category: '采访梗',
  },
  {
    id: 'j2',
    title: '经纪人 vs 艺人',
    text: '经纪人：这周别乱说话，稳住。艺人：好的！然后转头就在直播里把老板的黑历史全抖了出来。经纪人：我谢谢你。',
    author: '隔壁的猹',
    likes: '6.4万',
    category: '幕后梗',
  },
  {
    id: 'j3',
    title: '造型翻车自救指南',
    text: '红毯前：这造型绝了，我必是全场最佳。红毯后：评论区的兄弟姐妹，你们觉得我今天的卫衣怎么样？',
    author: '吃瓜群众乙',
    likes: '5.2万',
    category: '造型梗',
  },
  {
    id: 'j4',
    title: '粉丝接机名场面',
    text: '粉丝：哥哥！白屿洲：嘘——这是机场，你小声点。粉丝改口：哥～哥～ 全场爆笑，气氛组天花板。',
    author: '快乐搬运工',
    likes: '4.7万',
    category: '粉丝梗',
  },
];

export const reactions: ReactionItem[] = [
  {
    id: 'r1',
    title: '吃瓜网友真实反应：听到爆料那瞬间',
    source: '网友混剪',
    img: 'https://readdy.ai/api/search-image?query=Vertical%20cartoon%20illustration%20of%20surprised%20audience%20watching%20phone%20with%20gossip%20breaking%20news%2C%20speech%20bubbles%20and%20popcorn%2C%20cream%20background%2C%20watermelon%20coral%20palette%2C%20playful%20flat%20style&width=600&height=750&seq=gua-reaction-01&orientation=portrait',
    comments: '32.6万条评论',
  },
  {
    id: 'r2',
    title: '全网变脸名场面：从路人到吃瓜第一线',
    source: '热门投稿',
    img: 'https://readdy.ai/api/search-image?query=Vertical%20cartoon%20illustration%20of%20crowd%20quickly%20changing%20expression%20from%20normal%20to%20shocked%20when%20holding%20phone%2C%20cream%20background%2C%20green%20and%20coral%20palette%2C%20playful%20flat%20meme%20style&width=600&height=750&seq=gua-reaction-02&orientation=portrait',
    comments: '21.9万条评论',
  },
  {
    id: 'r3',
    title: '这段网友吐槽我能循环一天',
    source: '高能弹幕',
    img: 'https://readdy.ai/api/search-image?query=Vertical%20cartoon%20illustration%20of%20person%20laughing%20hard%20with%20tears%20watching%20barrage%20comments%20on%20screen%2C%20cream%20background%2C%20warm%20amber%20and%20coral%2C%20playful%20flat%20style&width=600&height=750&seq=gua-reaction-03&orientation=portrait',
    comments: '18.4万条评论',
  },
  {
    id: 'r4',
    title: '吃瓜吃到自己家是怎样的体验',
    source: '街访热梗',
    img: 'https://readdy.ai/api/search-image?query=Vertical%20cartoon%20illustration%20of%20a%20shocked%20person%20realizing%20the%20gossip%20is%20about%20themselves%20while%20holding%20watermelon%2C%20cream%20background%2C%20leaf%20green%20and%20coral%2C%20playful%20flat%20style&width=600&height=750&seq=gua-reaction-04&orientation=portrait',
    comments: '9.6万条评论',
  },
];

export const faqs: FaqItem[] = [
  {
    id: 'f1',
    q: '什么是"吃瓜"？',
    a: '吃瓜是网络流行语，指围观看热闹，尤其是围观娱乐明星和公众人物的各种事件与八卦。本站专注把这些"瓜"里的网友热评、弹幕、表情包和神梗段子都帮你整理好，吃瓜轻松不迷路。',
  },
  {
    id: 'f2',
    q: '网站内容是否真实可靠？',
    a: '本站聚焦网友们对娱乐事件的公开反应与评论，属于二次内容汇编。娱乐事件瞬息万变，评论区观点仅代表网友个人，我们会尽量注明来源，也希望大家理性吃瓜、友善发言。',
  },
  {
    id: 'f3',
    q: '热评、弹幕和段子是怎么选出来的？',
    a: '我们综合互动量、传播度与笑点密度，从海量评论中人工精选出最具代表性的热评与神梗，按话题热度、点赞量和评论区欢乐程度定期更新榜单。',
  },
  {
    id: 'f4',
    q: '我可以投稿自己的神评论或表情包吗？',
    a: '当然可以！欢迎通过页面底部的投稿入口把你看到的爆笑热评、自制表情包或神梗段子发给我们，优质内容经审核后会收录进对应专区，并为你署名。',
  },
  {
    id: 'f5',
    q: '表情包可以下载商用吗？',
    a: '站内表情包多数来自网友分享，仅供娱乐交流。若涉及个人肖像或受版权保护的作品，请勿直接商用或恶意传播，转载时尽量注明原始出处。',
  },
  {
    id: 'f6',
    q: '多久更新一次内容？',
    a: '我们会紧跟娱乐热点，热门大瓜一般实时跟进，常青栏目如神梗段子与表情包专区每周多次更新，确保你每次点开都有新快乐。',
  },
];